import React from 'react';

interface Props {
  onClose: () => void;
}

export default function CloseButton({ onClose }: Props): React.ReactElement {
  return (
    <button
      onClick={onClose}
      style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        background: 'rgba(0, 0, 0, 0.5)',
        border: 'none',
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        color: 'white',
        fontSize: '20px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
      }}
    >
      ×
    </button>
  );
}
